export default {
      id: "ic-plan-verre-usage",
      viewBox: "0 0 40 40",
      url: "../../../plugins/creasit-builder/assets/dist/images/" + "sprite.svg#ic-plan-verre-usage",
      toString: function () {
        return this.url;
      }
    }